import { useDripsyTheme, View } from 'dripsy';
import React from 'react';

import { FONT_SIZE, TextCaption } from '../typography';

const DEFAULT_BACKGROUND_COLOR = '#edfaff';
const DEFAULT_COLOR = '#28acff';

export enum BADGE_COLOR {
  DEFAULT = 'DEFAULT',
  BLUE = 'Blue',
  CYAN = 'Cyan',
  GREY = 'Grey',
  GREEN = 'Green',
  YELLOW = 'Yellow'
}

interface BadgeProps {
  label: string;
  variant: FONT_SIZE;
  backgroundColor?: string;
  textColor?: string;
  color?: BADGE_COLOR;
}

export const Badge: React.FC<BadgeProps> = ({ label, variant, backgroundColor, textColor, color }) => {
  const { theme } = useDripsyTheme();
  let badgeBackgroundColor = theme.colors[`$badge${color}Background`] || DEFAULT_BACKGROUND_COLOR;
  let badgeTextColor = theme.colors[`$badge${color}Text`] || DEFAULT_COLOR;

  return (
    <View
      sx={{
        paddingY: 2,
        paddingX: 5,
        width: 'fit-content',
        backgroundColor: badgeBackgroundColor,
        borderRadius: 100
      }}>
      <TextCaption
        variants={[variant]}
        sx={{
          color: badgeTextColor
        }}>
        {label}
      </TextCaption>
    </View>
  );
};
